<template>
    <div>
        <div class="card">
            <div class="card-header animated fadeInRightBig" >
                <div class="card-title">Solicitação de vale-transporte</div>      
            </div>
            <div class="card-body">
                <div class="row mb-3">
                     <div class="col-md-6">
                        <label><span class="required">*</span> Data</label>
                        <date-time 
                            v-model="transportationRequest.dateSelected"
                            format="YYYY-MM-DD"
                            formatted="DD/MM/YYYY"
                            output-format="YYYY-MM-DD"
                            :no-button-now="true"
                        >
                            <input type="text" class='form-control' :value="transportationRequest.date">
                        </date-time>
                    </div>
                    <div class="col-md-2 mt-4">
                        <button class="btn btn-info" @click="addDate">
                        Adicionar Data
                        </button>
                    </div>
                </div>
                    <div class="row">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                <th scope="col">Data</th>
                                <th scope="col">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(date, index) in transportationRequest.dates" :key="date">
                                <td>
                                    {{ formatDate(date) }}
                                </td>
                                <td>
                                    <button
                                    type="button"
                                    class="btn btn-crud delete"
                                    data-tooltip="tooltip"
                                    @click="destroy(index)"
                                    title="Excluir"
                                    >
                                    <i class="far fa-trash-alt"></i>
                                    </button>
                                </td>
                                </tr>
                            </tbody>
                        </table>
            </div>
                <div class="block text-right">
                    <router-link to="/transportationRequests" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                
                <div class="row">
                    <div class="col-md-4">
                        <p><span class="required">*</span> Campos Obrigatórios</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      users: [],
      transportationRequest: {
        dateSelected: "",
        dates: []
        // justification: '',
      }
    };
  },
  methods: {
    save: function() {
      const self = this;

      const api = this.$store.state.api + "transport_solicitations";

      let fd = self.makeFormData();
      if (!fd) return;

      self.$http
        .post(api, fd)
        .then(response => {
          self.$message(
            "Sucesso",
            `Solicitação de vale-transporte realizada com sucesso`,
            "success"
          );
          this.$router.push("/transportationRequests");
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeFormData: function() {
      const self = this;
      console.log(" aa");
      console.log(self.transportationRequest);
      let fd = new FormData();

      fd.append("date", self.transportationRequest.dates);

      fd.append("_method", "POST");

      return fd;
    },
    getTransportationRequest: function(id) {
      let self = this;
      let api = self.$store.state.api + "transport_solicitations/" + id;

      self.$http
        .get(api)
        .then(response => {
          self.transportationRequest = response.data.data[0];
        })
        .catch(error => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    addDate: function() {
      this.transportationRequest.dates.push(this.transportationRequest.dateSelected);
    },
    destroy(index) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            self.transportationRequest.dates.splice(index, 1);
            swal("Sucesso", "Registro excluído com sucesso!", "success");

            break;
        }
      });
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    }, 
  },
  mounted: function() {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getTransportationRequest(id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TransportationRequest/Add.vue